import type { DocumentModel } from '@/entities/Document'

import { AppPages } from '../AppRouter'

export interface IRoute<T extends object = {}> {
    name: string
    params?: T
}

export class AppRoutes {
    private constructor() {}

    static getMainPage() {
        return getRoute(AppPages.mainPage);
    }
    static getCabinet() {
        return getRoute(AppPages.personalAccount);
    }
    static getCreateDocument() {
        return getRoute(AppPages.createDocument);
    }
    static openDocument(id: number) {
        return getRoute(AppPages.documentInfo, { id });
    }
    static openIncomingDoc(id: number) {
        return getRoute(AppPages.incomingDoc, { id });
    }
    static openOutgoingDoc(id: number) {
        return getRoute(AppPages.outgoingDoc, { id });
    }
    static getDraftList() {
        return getRoute(AppPages.draftList, {});
    }
    static getDraftDocument(id: number) {
        return getRoute(AppPages.draftDocument, {id});
    }
    /** Страница документа, открытого из списка: у каждого списка своя */
    static openListDocument(type: DocumentModel.DocumentListType, id: number): IRoute<{ id: number }> {
        switch (type) {
            case 'incoming':
                return AppRoutes.openIncomingDoc(id);
            case 'outgoing':
                return AppRoutes.openOutgoingDoc(id);
            case 'draft':
                return AppRoutes.getDraftDocument(id);
            case 'trash':
                return getRoute('TrashDoc', { id });
        }
    }
    static getOutgoing() {
        return getRoute(AppPages.outgoing, {});
    }
    static getIncoming() {
        return getRoute(AppPages.incoming, {});
    }
    static getCabinetTariffs() {
        return getRoute(AppPages.cabinetTariffs, {});
    }
    static getMainCabinet() {
        return getRoute('CabinetMain', {});
    }
}

function getRoute<T extends object = {}>(name: string, params?: T): IRoute<T> {
    return {
        name,
        params
    }
}